<template>
  <transition name="fade">
    <section
      v-show="visible"
      :class="{'light-box--light': light}"
      class="light-box"
    >
      <div class="light-box__modal">
        <div
          class="light-box__modal__close"
          @click="handleClose()"
        >
          <ul>
            <li />
            <li />
          </ul>
        </div>
        <slot />
      </div>
    </section>
  </transition>
</template>

<script>
export default {
  name: 'LightBox',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../../../_src/sass/config/vars';
@import '../../../../_src/sass/config/mixins';
@import '../../../../_src/sass/config/responsive';

.light-box {
  align-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.85);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  max-width: 100vw;
  min-height: 100vh;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 999;

  .mobility & {
    @include teq-breakpoint($wide) {
      height: 120vh;
      left: -20vw;
      overflow: visible;
      top: -40vh;
      width: 120vw;
      z-index: 2000;
    }
  }

  .nav-open & {
    @include transform(translate(-90vw, 0));
  }

  &__modal {
    background: white;
    display: flex;
    max-width: 330px;
    //min-height: 200px;
    position: relative;

    @include teq-breakpoint($medium) {
      max-width: 580px;
      width: 100%;
    }

    &__close {
      background: black;
      cursor: pointer;
      height: 50px;
      padding: 5px;

      /* this is the top right arrow */
      position: absolute;
      right: 0;
      top: 0;
      width: 50px;

      @include teq-breakpoint($medium) {
        right: -8px;
        top: -34px;
      }

      /* I code a cross with the li, then I rotated the parent 45deg */
      ul {
        height: 20px;
        position: relative;

        @include rotate(45deg);
      }

      li {
        background-color: white;
        height: 2px;
        width: 20px;

        .light-box--light & {
          background-color: white;
        }

        &:nth-child(2) {
          @include transform(translate(10px, 8px));
        }

        &:nth-child(1) {
          @include rotate(90deg);

          margin-left: 50%;
          margin-top: 4px;
          transform-origin: left;
        }
      }

      @include teq-breakpoint($medium) {
        right: 0;
        top: 0;
      }
    }
  }
}
</style>
